module.exports = __webpack_public_path__ + "img/strip-1.8cc25edd.svg";